export const SEARCH_DEFAULT_LIMIT = 10;

export const SEARCH_MAX_LIMIT = 100;

export const SEARCH_LOAD_STEP = 10;
